'use client';

import { useState } from 'react';
import Image from 'next/image';
import { useLocale, useTranslations } from 'next-intl';
import { usePathname } from '@/navigation';
import { TrackedAnchor } from '@/components/ancher';
import { REF_SOURCE } from '@/constants';

const BANNER_SRC: Record<string, string> = {
  ko: '/images/gene-browser-ad-ko.webp',
  en: '/images/gene-browser-ad-en.webp',
};

/**
 * Gene Browser 상세 페이지에 표시되는 가로형 프로모션 배너 광고
 */
export default function GeneBrowserBannerAd() {
  const locale = useLocale();
  const geneId = usePathname().split('/').pop() ?? '';
  const t = useTranslations('GeneBrowser.bannerAd');
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className="col-start-2 hidden pt-10 lg:block">
      <div className="relative mx-auto max-w-[960px]">
        <button
          type="button"
          onClick={() => setDismissed(true)}
          className="absolute right-2.5 top-2.5 z-10 flex size-7 items-center justify-center rounded-md transition-opacity hover:opacity-70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50"
          aria-label={t('close')}
        >
          <svg
            width="12"
            height="12"
            viewBox="0 0 22 22"
            fill="none"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.07 0.36a1.23 1.23 0 0 1 1.75 1.74l-8.99 8.99 8.99 8.99a1.23 1.23 0 0 1-1.75 1.74L11.09 12.83l-8.99 8.99a1.23 1.23 0 0 1-1.74-1.74l8.99-8.99L.36 2.1A1.23 1.23 0 0 1 2.1.36l8.99 8.99L20.07.36Z"
              fill="white"
            />
          </svg>
        </button>
        <TrackedAnchor
          href={`/providers?ref=${REF_SOURCE.GENE_BROWSER_AD}&from=${encodeURIComponent(geneId)}`}
          target="_blank"
          rel="noopener"
          label="gene_browser_banner_ad"
          position="main_content"
        >
          <Image
            src={BANNER_SRC[locale] ?? BANNER_SRC.en}
            alt={t('alt')}
            width={9276}
            height={2880}
            quality={100}
            className="w-full rounded-xl"
          />
        </TrackedAnchor>
      </div>
    </div>
  );
}
